export default __webpack_public_path__ + "static/media/login.a44fd369.png";